import React, { useEffect, useState } from 'react';
import { Modal, Spin, message, Tabs } from 'antd';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { getCardsOperator } from '~/services/hooks/cardsOperator';
import {
  createEventsFinancials,
  getEventsFinancials,
  pdfEventsFinancials,
  updateEventsFinancials,
} from '~/services/hooks/eventFinancials';
import FinancialClosingRevenues from './financialClosingRevenues';
import Real from './real';
import Client from './client';
import FinancialClosingPayAndLoss from './financialClosingPayAndLoss';
import IsMobile from '~/services/mobileCheck';
import errorHandler from '~/Utils/errorHandler';

const initial = {
  event_id: null,
  revenues: [],
  event_financial_payments: [],
  event_financial_losses: [],
  debit_fee: 0,
  credit_fee: 0,
  anticipation_fee: '0',
  agio: '0',
  debit_raw_price: null,
  debit_fee_price: null,
  debit_final_price: null,
  credit_raw_price: null,
  credit_fee_price: null,
  credit_liquid_price: null,
  credit_final_price: null,
  anticipation_price: '0.00',
  revenues_price: null,
  final_price: null,
  customer_final_price: null,
  payments_price: null,
  agio_total: null,
  pix_raw_price: null,
  pix_fee_price: null,
  pix_final_price: null,
  pix_fee: 0,
};

export default function FinancialClosingModal({ visible, onClose, event }) {
  const { t } = useTranslation();
  const isMobile = IsMobile();
  const [loading, setLoading] = useState(false);
  const [cardsOperators, setCardsOperators] = useState([]);
  const [initialValues, setInitialValues] = useState(initial);

  const fetchRevenues = async () => {
    try {
      const response = await getEventsFinancials('', `by-event/${event.id}`);

      setInitialValues(response);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  const fetchCardsOperator = async () => {
    try {
      const data = await getCardsOperator('', 'no-paginated');
      setCardsOperators(data);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  const handleTitle = (values, index, cards) => {
    const firstTitle = cardsOperators?.find((co) => co.id === values?.revenues[index]?.card_operator_id)?.name || '';
    const secondTitle = cards?.find((c) => c.id == values?.revenues[index]?.card_id)?.card_type_name || '';

    return firstTitle && secondTitle ? firstTitle + ' - ' + secondTitle : firstTitle;
  };

  const handleSave = async (values, { setErrors }) => {
    setLoading(true);
    try {
      if (values?.id) {
        await updateEventsFinancials(values?.id, values);
      } else {
        values.event_id = event.id;
        await createEventsFinancials(values);
      }
      message.success(t('messages:successCreate'));
      onClose();
    } catch (error) {
      console.error('Erro ao salvar:', error);
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  const handlePdf = async (eventFinancials, route) => {
    try {
      const { data } = await pdfEventsFinancials(eventFinancials, route);
      window.open(data.data, '_blank');
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (visible) {
      if (event?.event_financials_id) {
        fetchRevenues();
      } else {
        setInitialValues(initial);
      }
      fetchCardsOperator();
    }
  }, [visible]);

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSave}
    >
      {({ values, submitForm, setFieldValue }) => (
        <Modal
          title={`Fechamento Financeiro - ${event?.name}`}
          open={visible}
          onCancel={onClose}
          afterClose={() => setInitialValues({})}
          width={1000}
          footer={<ModalFooter onOk={submitForm} onCancel={onClose} loading={loading} />}
        >
          <Spin spinning={loading}>
            <Tabs
              defaultActiveKey="1"
              size="large"
              items={[
                {
                  label: 'Valores',
                  key: 'Valores',
                  children: (
                    <div>
                      <FinancialClosingRevenues
                        values={values}
                        setFieldValue={setFieldValue}
                        cardsOperators={cardsOperators}
                        handleTitle={handleTitle}
                      />
                    </div>
                  ),
                },
                {
                  label: 'Real',
                  key: 'Real',
                  children: <Real handlePdf={handlePdf} values={values} loading={loading} />,
                },
                {
                  label: 'Cliente',
                  key: 'Cliente',
                  children: <Client handlePdf={handlePdf} values={values} loading={loading} />,
                },
                {
                  label: 'Pagamentos & Sobra/Falta',
                  key: 'Pagamentos & Sobra/Falta',
                  children: (
                    <>
                      <div style={{ marginTop: '30px' }}>
                        <FinancialClosingPayAndLoss values={values} isMobile={isMobile} />
                      </div>
                    </>
                  ),
                },
              ]}
            />
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
